const ContentCopy = {
  'page.content.title': 'Manage content',
  'page.content.tabs.sections.label': 'Sections',
  'page.content.tabs.actions.label': 'Missions',
  'page.content.tabs.campaigns.label': 'Campaigns',
}

const ActionsCopy = {
  'page.content.actions.title': 'Manage missions',
  'page.content.actions.btn.create-action': 'Create mission',
  'page.content.actions.search.placeholder': 'Search missions...',
  'page.content.actions.search.aria-label': 'Search missions',
  'page.content.actions.filters.all': 'All',
  'page.content.actions.filters.ayo': 'Add your own',
  'page.content.actions.filters.missions': 'Missions',
  'page.content.actions.filters.pledges': 'Pledges',
  'page.content.actions.filters.group-missions': 'Group missions',
  'page.content.actions.hero-points': '{heroPoints} Hero points earned',
  'page.content.actions.missing-image.alt': 'Missing image',
}

const SectionsCopy = {
  'page.content.sections.title': 'Manage sections',
  'page.content.sections.btn.create-section': 'Create section',
  'page.content.sections.edit.owner': 'Owner {name}',
  'page.content.sections.added-actions.title': 'Edit section',
  'page.content.sections.actions.title': 'Search for missions',
  'page.content.sections.actions.description': "Let's find something to add to your section.",
  'page.content.sections.search-type.actions': 'Missions ({num})',
  'page.content.sections.search-type.task-types': 'Task types ({num})',
  'page.content.sections.filters.unpublished': 'Unpublished',
  'page.content.sections.filters.public': 'Public',
  'page.content.sections.filters.targeted': 'Targeted',
  'page.content.section.action.add': 'Add',
  'page.content.section.action.remove': 'Remove',
  'page.content.section.action.details':
    '{numActions} individual missions • {numTaskTypes} task types',
  'page.content.section.table.th.name': 'Name',
  'page.content.section.table.th.access': 'Access',
  'page.content.section.table.th.created': 'Created',
  'page.content.section.table.th.active': 'Active',
  'page.content.section.table.th.updated': 'Updated',
  'page.content.section.table.th.category': 'Category',
  'page.content.section.table.no-data': 'There are currently no {status} sections.',
  'page.content.section.menu.button.edit': 'Edit',
  'page.content.section.quick-access.edit-name': 'Edit name',
  'page.content.section.quick-access.change-position': 'Change position',
  'page.content.section.quick-access.update-access': 'Update access',
  'page.content.section.quick-access.unpublish': 'Unpublish',
  'page.content.section.quick-access.delete': 'Delete',
  'page.content.section.category.action': 'Mission',
  'page.content.section.category.action.pledge': 'Pledge',
  'page.content.section.category.action.mission': 'Mission',
  'page.content.section.category.task-type': 'Task type',
}

const SectionsPermissionsCopy = {
  'page.content.section.permissions.title': 'Who can view "{name}"',
  'page.content.section.permissions.btn.publish': 'Publish section',
  'page.content.section.permissions.targeted.note':
    'Only teams or people added below can access this section',
  'page.content.section.permissions.targeted.search.placeholder':
    'Search for people, teams, or organisations',
  'page.content.section.permissions.targeted.people': 'People',
  'page.content.section.permissions.targeted.teams': 'Teams',
  'page.content.section.permissions.targeted.organisations': 'Organisations',
  'page.content.section.permissions.access-filter.public': 'Public',
  'page.content.section.permissions.access-filter.public-locked':
    'Public - remove people, teams, and orgs first',
  'page.content.section.permissions.access-filter.targeted': 'Targeted',
}

const SectionModalsCopy = {
  'page.content.sections.modal.delete.title': 'Delete this section?',
  'page.content.sections.modal.delete.description':
    'Once deleted, users won’t be able to access this section and it can’t be retrieved',

  'page.content.sections.modal.change-position.title': 'Change position',
  'page.content.sections.modal.change-position.description':
    'Enter a number for the position that this section will appear on the Dashboard and App.',
  'page.content.sections.modal.change-position.current': 'Current position: {position}',

  'page.content.sections.modal.change-filter-position.description':
    'Enter a number for the position that this section will appear on the Dashboard and App.',

  'page.content.sections.modal.new-section.title': 'Name your new section',
  'page.content.sections.modal.new-section.description':
    'Enter a name for your section that highlights what it’s about and / or who it’s intended for. Don’t worry you can change it later.',

  'page.content.sections.modal.edit-section.title': 'Name your section',
  'page.content.sections.modal.edit-section.description':
    'Enter a name for your section that highlights what it’s about and / or who it’s intended for. Don’t worry you can change it later.',

  'page.content.sections.modal.unpublish-section.title': 'Unpublish?',
  'page.content.sections.modal.unpublish-section.description':
    'Users won’t be able to access this section. You will have to assign permissions again to make it live.',
}

const SectionNotificationCopy = {
  'page.content.sections.notification.new-section': '"{name}" has been created.',
  'page.content.sections.notification.change-order': "Section's position changed to {offset}",
  'page.content.sections.notification.delete': '"{name}" has been deleted.',
  'page.content.sections.notification.delete.permission-failure':
    'You can not have permission to delete "{name}".',
  'page.content.sections.notification.edit.permission-failure':
    'You can not have permission to edit "{name}".',
  'page.content.sections.notification.rename': 'Section renamed to "{name}".',
  'page.content.sections.notification.publish.public': '"{name}" is now live.',
  'page.content.sections.notification.saved': '"{name}" saved.',
  'page.content.sections.notification.unpublished': '"{name}" is no longer live.',
}

const CampaignCopy = {
  'page.content.campaigns.title': 'Manage campaigns',
  'page.content.campaigns.btn.create-campaign': 'Create campaign',
  'page.content.campaigns.modal.new-campaign.title': 'Create a new campaign',
  'page.content.campaigns.modal.new-campaign.description':
    'Add a title to your campaign, you can always change these bits and bobs later.',
  'page.content.campaigns.modal.new-campaign.name.label': 'Name*',
  'page.content.campaigns.modal.new-campaign.summary.label': 'Summary*',
  'page.content.campaigns.modal.delete.title': 'Delete this campaign?',
  'page.content.campaigns.modal.delete.description':
    "Once deleted, users won't be able to access this campaign and it can't be retrieved",
  'page.content.campaigns.notification.new-campaign.error.title':
    '{code} - Error creating campaign',
  'page.content.campaigns.notification.new-campaign.error.description':
    "You probably don't have permissions to create a campaign. If you think you should have this permission, please reach out to the tech team.",
  'page.content.campaigns.notification.new-campaign': '"{title}" has been created.',
  'page.content.campaigns.notification.save-campaign': '"{title}" has been saved.',
  'page.content.campaigns.notification.delete': '"{name}" has been deleted.',
  'page.content.campaigns.notification.delete.permission-failure':
    'You don\'t have permission to delete "{name}".',
}

const EditCampaignCopy = {
  'page.content.campaigns.edit.tab.details': 'Details',
  'page.content.campaigns.edit.tab.appearance': 'Appearance',
  'page.content.campaigns.edit.tab.missions': 'Missions',
  'page.content.campaigns.edit.tab.preview': 'Preview',
  'page.content.campaigns.edit.details.dates.label': 'Campaign dates*',
  'page.content.campaigns.edit.details.dates.unlimited': 'No fixed dates',
  'page.content.campaigns.edit.details.title.label': 'Title*',
  'page.content.campaigns.edit.details.title.hint': 'Title has a maximum length of 25 characters',
  'page.content.campaigns.edit.details.summary.label': 'Summary*',
  'page.content.campaigns.edit.details.summary.hint':
    'Summary has a maximum length of 75 characters',
  'page.content.campaigns.edit.details.missions-header.toggle.label': 'Change the missions header',
  'page.content.campaigns.edit.details.missions-header.input.label': 'Custom missions label*',
  'page.content.campaigns.edit.details.missions-header.input.placeholder': 'Missions',
  'page.content.campaigns.edit.details.missions-header.input.hint':
    'This sits above the list of missions',
  'page.content.campaigns.edit.details.stats.toggle.label': 'Include a statistic about the cause',
  'page.content.campaigns.edit.details.stats.value.label': 'Statistic value*',
  'page.content.campaigns.edit.details.stats.value.placeholder': '30%',
  'page.content.campaigns.edit.details.stats.value.hint':
    'Statistic value has a maximum length of 4 characters',
  'page.content.campaigns.edit.details.stats.stat-label.label': 'Statistic label*',
  'page.content.campaigns.edit.details.stats.stat-label.placeholder':
    'of adults in the UK have experienced mental health issues',
  'page.content.campaigns.edit.details.stats.stat-label.hint':
    'Statistic label has a maximum length of 70 characters',
}

const EditCampaignAppearance = {
  'page.content.edit.appearance.pattern.title': 'Background pattern',
  'page.content.edit.appearance.colours.title': 'Colours',
  'page.content.edit.appearance.options.title': 'Options',
  'page.content.edit.appearance.background.title': 'Background pattern',
  'page.content.edit.appearance.colours.primary-background.title': 'Primary background',
  'page.content.edit.appearance.colours.primary-text.title': 'Primary text',
  'page.content.edit.appearance.colours.secondary-background.title': 'Secondary background',
  'page.content.edit.appearance.colours.secondary-text.title': 'Secondary text',
  'page.content.edit.appearance.colours.date-background.title': 'Date box background',
  'page.content.edit.appearance.colours.date-text.title': 'Date box text',
  'page.content.edit.appearance.colours.summary-background.title': 'Summary box background',
  'page.content.edit.appearance.colours.summary-text.title': 'Summary box text',
  'page.content.edit.appearance.colours.stat-background.title': 'Stat box background',
  'page.content.edit.appearance.colours.stat-text.title': 'Stat box text',
  'page.content.edit.appearance.colours.sticker.background.title': 'Sticker background',
  'page.content.campaigns.edit.appearance.border.toggle.label': 'Show box borders',
  'page.content.campaigns.edit.appearance.sticker.toggle.label': 'Include sticker',
}

export const CampaignTable = {
  'page.content.campaigns.table.title.label': 'Title',
  'page.content.campaigns.table.date.label': 'Date created',
  'page.content.campaigns.table.active.label': 'Active',
  'page.content.campaigns.button.remove': 'Remove from campaign',
  'page.content.campaigns.button.add': 'Add',
}

export const CampaignPopups = {
  'page.content.campaigns.modal.unpublish-campaign.title': 'Unpublish campaign?',
  'page.content.campaigns.modal.unpublish-campaign.description':
    "Users won't be able to access this campaign. You will have to assign permissions again to make it live.",
  'page.content.campaigns.modal.permissions.title': 'Update campaign permissions',
}

export default {
  ...ContentCopy,
  ...SectionsCopy,
  ...SectionModalsCopy,
  ...SectionNotificationCopy,
  ...SectionsPermissionsCopy,
  ...ActionsCopy,
  ...CampaignCopy,
  ...EditCampaignCopy,
  ...CampaignTable,
  ...EditCampaignAppearance,
  ...CampaignPopups,
}
